import { css } from "@emotion/core";

export const BASE_GUTTER_SPACE = 8;
export const FONT_SIZES = {
    BASE: "14px",
    H1: "28px",
    H2: "24px",
    H3: "20px",
    H4: "16px",
    H5: "14px",
};

// Fonts
export const FONT_THIN = 300;
export const FONT_MID = 500;
export const FONT_BOLD = 800;

export const FONTS = {
    CERA: "Cera",
};
export const BASE_FONT = `${FONTS.CERA}, "Helvetica Neue", Helvetica, Arial, sans-serif`;

// Colors
export const BG_PRIMARY = `#fd7685`;
export const BRAND_PRIMARY_COLOR = `#fd7685`;
export const BOX_SHADOW_COLOR = "#ccc";
export const BG_BASE = `#fff`;
export const BG_SECONDARY = `#d8d8d8`;
export const BG_GREY = "#f6f7f9";
export const TEXT_PRIMARY = `#000`;
export const TEXT_SECONDARY = `#9b9b9b`;
export const TEXT_TERTIARY = `#4a4a4a`;
export const TEXT_INVERTED = `${BG_BASE}`;
export const TAG_DEFAULT_COLOR = "#ebf4ff";
export const BANNER_SHADOW = "2px 3px 0 rgba(0, 0, 0, 0.1)";
export const BANNER_SHADOW_HOVER = "0 2px 12px 0 rgba(0, 0, 0, 0.3)";

export const DWEB_HEADER_HEIGHT = 85;
export const DWEB_DISCOUNT_HEIGHT = 24;

export const MWEB_HEADER_HEIGHT = 50;
export const MWEB_HEADER_DISCOUNT_HEIGHT = 75;
export const DWEB_MAX_WIDTH = 1200;

export const MWEB_HEADER_ZINDEX = 10;
export const OVERLAY_ZINDEX = 1000;

export const MWEB_HEADER_ICON_WIDTH = 40;

export const COLORS = {
    ERROR_TEXT: "#b60100",
    PLACEHOLDER: "#f4f4f4",
    BLACK_100: "#001325",
    BLACK_92: "#142536",
    BLACK_64: "#5c6874",
    BLACK_36: "#a3aab0",
    BLACK_24: "#c2c7cb",
    BLACK_16: "#d6d9dc",
    BLACK_8: "#ebedee",
    BRAND_PRIMARY_100: "#fd7685",
};

export const OVERLAY_CSS = css`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: ${OVERLAY_ZINDEX};
    background-color: rgba(0, 0, 0, 0.5);
`;

export const HIDE_SCROLLBARS = css`
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        background: transparent;
    }
`;

export const BREAKPOINTS = {
    DESKTOP: 1100,
    TABLET_BIG: 1024,
    TABLET: 768,
    MOBILE: 414,
};

export const MEDIA_BREAKPOINTS = {
    TABLET_BIG: `@media (min-width: ${BREAKPOINTS.TABLET_BIG + 1}px) and (max-width: ${
        BREAKPOINTS.DESKTOP
    }px)`,
    TABLET: `@media (min-width: ${BREAKPOINTS.TABLET}px) and (max-width: ${
        BREAKPOINTS.TABLET_BIG
    }px)`,
    TILL_DESKTOP: `@media (max-width: ${BREAKPOINTS.DESKTOP}px)`,
    TILL_TABLET_BIG: `@media (max-width: ${BREAKPOINTS.TABLET_BIG}px)`,
    TILL_TABLET: `@media (max-width: ${BREAKPOINTS.TABLET}px)`,
    MOBILE: `@media (max-width: ${BREAKPOINTS.MOBILE}px)`,
};
